import React, {useState, useEffect} from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";

import { Autocomplete, Checkbox, FormControlLabel, TextField } from "@mui/material" 
import { Button } from "@material-ui/core";
import { addSite } from "../../services/MetadataService";

const AddSchool = () =>{
    const [states, setStates] = useState(['CA - California', 'OR - Oregon', 'WA - Washington'])
    const [levels, setLevels] = useState(["High","Middle","Elementary","Elementary-High","Trade","Art","College or University"])
    const [districts, setDistricts] = useState([])
    const [schools, setSchools] = useState([])
    const [utilities, setUtilities] = useState([])
    const [counties, setCounties] = useState([])
    const [selectedState, setSelectedState] = useState()
    const [selectedDistrict, setSelectedDistrict] = useState()
    const [selectedSchool, setSelectedSchool] = useState()
    const [districtNotListed, setDistrictNotListed] = useState(false)
    const [schoolNotListed, setSchoolNotListed] = useState(false)
    const [toast, setToast] = useState()

    let history = useHistory();

    //Run these on load
    useEffect(() => {
        if (districts.length == 0) getSchoolDistricts();
        if (utilities.length == 0) getUtilities();
    },[])



    const getUtilities = () => {
		var Airtable = require('airtable');
		var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app3iO6COcyP8sQpR');
		
		let utilities = [];
		base('utility_dim').select({
			// Selecting the first 3 records in Grid view:
			maxRecords: 5000,
			view: "Grid view"
		}).eachPage((records, fetchNextPage) => {		
			records.forEach(function(record) {
                let state = record.get('state')
				let utility = {
					id: record.get('utility_id'),
					abbr: record.get('utility_abbr'),
                    name: state + " - " + record.get('utility_name')
				};

				utilities.push(utility);
			});

			fetchNextPage();
		
		},  (err) => {
			if (err) { console.error(err); return; }
            utilities.sort((a,b) => a.name.localeCompare(b.name))
            console.log(utilities)
            setUtilities(utilities)
		});
    }

    const getSchoolDistricts = () => {
		var Airtable = require('airtable');
		var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('appOaeovXlhJfwO2q');
		
		let allDistricts = [];
		base('school_district_dim').select({
			// Selecting the first 3 records in Grid view:
			maxRecords: 5000,
			view: "Grid view"
		}).eachPage((records, fetchNextPage) => {		
			records.forEach(function(record) {
				let district = {
					id: record.get('school_district_id'),
					district_name: record.get('district_name'),
					address1: record.get('address1'),
					city: record.get('city'),
                    state: record.get('state'),
                    postal_code: record.get('postal_code'),
				};

				allDistricts.push(district);
			});

			fetchNextPage();
		
		},  (err) => {
			if (err) { console.error(err); return; }
            setDistricts(allDistricts);
		});
    }

    const getSchools = (district) => {
		var Airtable = require('airtable');
		var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('appOaeovXlhJfwO2q');
		
		let allSchools = [];
		base('school_dim').select({
			// Selecting the first 3 records in Grid view:
			maxRecords: 5000,
			view: "Grid view",
            filterByFormula:  "SEARCH('" + district + "',{District Name})"
		}).eachPage((records, fetchNextPage) => {		
			records.forEach(function(record) {
				let school = {
					id: record.get('school_id'),
					district: record.get('District Name'),
                    name: record.get('school_name'),
                    type: record.get('school_type'),
                    level: record.get('school_level'),
					address1: record.get('address1'),
					city: record.get('city'),
                    state: record.get('state'),
                    postal_code: record.get('postal_code'),
                    enrollment: record.get('enrolled'),
                    electric_utility: record.get('IOU Electric'),
                    gas_utility: record.get('IOU Gas'),
                    is_low_enviroscore: record.get('is_top_cal_enviroscreen'),
                    is_low_income: record.get('is_low_income')
				};

				allSchools.push(school);
			});

			fetchNextPage();
		
		},  (err) => {
			if (err) { console.error(err); return; }
            setSchools(allSchools)
		});
    }

    const setSchoolDistrict = (district) => {
        let districtName = (district.target && district.target.value) ? district.target.value : district
        setSelectedDistrict(districtName)
        getSchools(districtName)
    }

    const setSchool = (school) => {
        let schoolName = (school.target && school.target.value) ? school.target.value : school

        let selectedSchool = schools.find(s => s.name === schoolName) || { name: schoolName, district: selectedDistrict }
        selectedSchool.state = selectedState;
        setSelectedSchool(selectedSchool)
        getCounties(selectedSchool.state);
    }

    const getCounties = (state) => {
		var Airtable = require('airtable');
		var base = new Airtable({apiKey: 'patCIEwoxkUzvEYn5.50de4bf9db9e737be83adc1099d3a3a4763f93dd327599a3504596a0e3e933fe'}).base('app7kfG35eQYRupcU');
		
		let counties = [];
		base('climate_zone_lookup').select({
			// Selecting the first 3 records in Grid view:
			maxRecords: 5000,
			view: "Grid view",
            filterByFormula:  "SEARCH('" + state + "',{state})"
		}).eachPage((records, fetchNextPage) => {		
			records.forEach(function(record) {
				let county = {
					county: record.get('county'),
					climate_zone: record.get('climate_zone_text'),
				};

				counties.push(county);
			});

			fetchNextPage();
		
		},  (err) => {
			if (err) { console.error(err); return; }
            setCounties(counties)
		});
    }

    const checkRequiredFields = () => {
        if (selectedSchool && selectedSchool.address1 && selectedSchool.city && 
            selectedSchool.state && selectedSchool.postal_code && selectedSchool.level
            && selectedSchool.county && selectedSchool.enrollment && selectedSchool.electric_utility
            && selectedSchool.customer_code && selectedSchool.project_code)
            return true;
        else return false;
    }

    const updateAddress1 = (e) => {
        let school = {...selectedSchool };
        school.address1 = e.target.value;
        setSelectedSchool(school)
    }

    const updateAddress2 = (e) => {
        let school = {...selectedSchool };
        school.address2 = e.target.value;
        setSelectedSchool(school)
    }

    const updateCity = (e) => {
        let school = {...selectedSchool };
        school.city = e.target.value;
        setSelectedSchool(school)
    }

    const updateState = (e) => {
        let school = {...selectedSchool };
        school.state = e.target.value;
        setSelectedSchool(school)
        getCounties(school.state);
    }

    const updateZip = (e) => {
        let school = {...selectedSchool };
        school.postal_code = e.target.value;
        setSelectedSchool(school)
    }

    const updateCounty = (value) => {
        let school = {...selectedSchool };
        school.county = value.county;
        school.climate_zone = value.climate_zone;
        setSelectedSchool(school)
    }

    const updateLevel = (level) => {
        let school = {...selectedSchool };
        school.level = level;
        setSelectedSchool(school)
    }

    const updateUtility = (utility) => {
        let school = {...selectedSchool };
        school.electric_utility = utility;
        setSelectedSchool(school)
    }

    const updateEnrolled = (e) => {
        let school = {...selectedSchool };
        school.enrollment = e.target.value;
        setSelectedSchool(school)
    }

    const updateCustomerCode = (e) => {
        let school = {...selectedSchool };
        school.customer_code = e.target.value;
        setSelectedSchool(school)
    }

    const updateProjectCode = (e) => {
        let school = {...selectedSchool };
        school.project_code = e.target.value;
        setSelectedSchool(school)
    }

    const updateProjectURL = (e) => {
        let school = {...selectedSchool };
        school.project_url = e.target.value;
        setSelectedSchool(school)
    }

    const updateFilesURL = (e) => {
        let school = {...selectedSchool };
        school.files_url = e.target.value;
        setSelectedSchool(school)
    }

    const updateEnviroscreen = (e) => {
        let school = {...selectedSchool };
        school.is_low_enviroscore = e.target.value;
        setSelectedSchool(school)
    }

    const updateIsLowIncome = (e) => {
        let school = {...selectedSchool };
        school.is_low_income = e.target.value;
        setSelectedSchool(school)
    }


    const submitSchool = () => {
        let school = selectedSchool;
        if (school.electric_utility && !school.electric_utility.id) {
            school.electric_utility = utilities.find(u => u.abbr === selectedSchool.electric_utility)
        }

        console.log(school)

        addSite(school).then(response => {
            history.push("/locations")
        }).catch(err => {
            setToast("Error adding site " + "(" + err + ")")
        });
      }

        let currentDistricts = selectedState ?
            districts.filter(f => f.state === selectedState).map(district => {
                return district.district_name
            }) : []

        let currentSchools = !districtNotListed && selectedDistrict ?
            schools.map(school => {
                return school.name
            }) : []

        let utility = null;
        if (selectedSchool && utilities) {
            utility = utilities.find(u => u.abbr === selectedSchool.electric_utility)
        }
        return <div className="layer3">
            <div className="school_add">
                <div className="school_selection_row">
                    <Autocomplete
                        disablePortal
                        id="searchable"
                        options={states}
                        renderInput={(params) => <TextField {...params} label="State" variant="outlined" fullWidth size="small" />}
                        size="small"
                        onChange={(event, newValue) => {
                            setSelectedState(newValue.substr(0, 2));
                        }}
                    />
                </div>
                {
                    selectedState ?
                            districtNotListed ?
                                <div className="school_selection_row">
                                    <TextField label="School District" variant="outlined" fullWidth required size="small" onChange={setSchoolDistrict}/>
                                </div>
                            :
                            <div className="school_selection_row">
                                <Autocomplete
                                    disablePortal
                                    id="searchable"
                                    options={currentDistricts}
                                    size="small"
                                    renderInput={(params) => <TextField {...params} label="School District" variant="outlined" required fullWidth size="small"/>}
                                    onChange={(event, newValue) => {
                                        setSchoolDistrict(newValue)
                                    }}
                                />
                                {
                                    selectedDistrict ? null :
                                        <Button href="#text-buttons" onClick={() => setDistrictNotListed(true)}>My district isn't listed</Button>
                                }
                                
                            </div>
                     : null
                }
                {
                    selectedDistrict ?
                        schools.length == 0 || schoolNotListed ?
                            <div className="school_selection_row">
                                <TextField label="School" variant="outlined" fullWidth required size="small" onChange={setSchool}/>
                            </div>
                            :
                            <div className="school_selection_row">
                                <Autocomplete
                                    disablePortal
                                    id="searchable"
                                    options={currentSchools}
                                    size="small"
                                    renderInput={(params) => <TextField {...params} label="School" variant="outlined" fullWidth required size="small" />}
                                    onChange={(event, newValue) => {
                                        setSchool(newValue)
                                    }}
                                />
                        
                                { selectedSchool ? null :
                                    <Button href="#text-buttons" onClick={() => setSchoolNotListed(true)}>My school isn't listed</Button>
                                }
                            </div> 
                        : null
                }
                                
                {
                    selectedSchool ?
                        <div className="school_selection_row">
                            <Autocomplete
                                disablePortal
                                id="searchable"
                                options={levels}
                                renderInput={(params) => <TextField {...params} label="Type of School" variant="outlined" fullWidth required size="small" />}
                                size="small"
                                onChange={(event, newValue) => {
                                    updateLevel(newValue)
                                }}
                            />
                        </div> : null
                }
                
                {
                    selectedSchool ? 
                        <div className="school_selection_row">
                            <TextField value={selectedSchool.address1 || ''} label="Address 1" variant="outlined" required fullWidth size="small" onChange={updateAddress1} />
                        </div> : null
                }

                {
                    selectedSchool ? 
                        <div className="school_selection_row">
                            <TextField value={selectedSchool.address2 || ''} label="Address 2" variant="outlined" fullWidth size="small" onChange={updateAddress2}/>
                        </div> : null
                }

                {
                    selectedSchool ? 
                        <div className="school_selection_row aligned">
                            <TextField value={selectedSchool.city || ''} label="City" variant="outlined" size="small" required onChange={updateCity}/>
                            <TextField value={selectedState || ''} label="State" variant="outlined" size="small" required width={50} onChange={updateState}/>
                            <TextField value={selectedSchool.postal_code || ''} label="Zip Code" variant="outlined" size="small" required onChange={updateZip}/>
                        </div> : null
                }

                {
                    selectedSchool && selectedSchool.state && counties  ? 
                        <div className="school_selection_row">
                            <Autocomplete
                                disablePortal
                                getOptionLabel={option => option.county}
                                id="counties"
                                options={counties}
                                size="small"
                                renderInput={(params) => <TextField {...params} label="County" variant="outlined" fullWidth required size="small" />}
                                onChange={(event, newValue) => {
                                    updateCounty(newValue)
                                }}
                            />
                        </div> : null
                }

                {
                    selectedSchool ? 
                        <div className="school_selection_row aligned">
                            <TextField value={selectedSchool.enrollment} label="Enrolled" variant="outlined" size="small" required onChange={updateEnrolled}/>
                            <Autocomplete
                                disablePortal
                                getOptionLabel={option => option.name}
                                id="utilities"
                                options={utilities}
                                style={{ width: "60%"}}
                                size="small"
                                renderInput={(params) => <TextField {...params} value={utility} label="Electric" variant="outlined" fullWidth required size="small" />}
                                onChange={(event, newValue) => {
                                    console.log(newValue)
                                    updateUtility(newValue)
                                }}
                            />
                            
                        </div> : null
                }

                {
                    selectedSchool ? 
                        <div className="school_selection_row aligned">
                            <TextField value={selectedSchool.customer_code} label="Customer Code" variant="outlined" size="small" required onChange={updateCustomerCode}/>
                            -
                            <TextField value={selectedSchool.project_code} label="Project Code" variant="outlined" size="small" required onChange={updateProjectCode}/>
                        </div> : null
                }

                {
                    selectedSchool ? 
                        <div className="school_selection_row aligned">
                            <TextField value={selectedSchool.project_url} label="Monday Project URL" variant="outlined" fullWidth required onChange={updateProjectURL}/>
                        </div> : null
                }

                {
                    selectedSchool ? 
                        <div className="school_selection_row aligned">
                            <TextField value={selectedSchool.files_url} label="Google Drive URL" variant="outlined" fullWidth required onChange={updateFilesURL}/>
                        </div> : null
                }

                {
                    selectedSchool ? 
                        <div className="school_selection_row aligned">
                            <FormControlLabel control={<Checkbox defaultChecked={selectedSchool.is_low_income} onChange={updateIsLowIncome} />} label="Is Low Income?" />
                            <FormControlLabel control={<Checkbox defaultChecked={selectedSchool.is_low_enviroscore} onChange={updateEnviroscreen} />} label="Enviroscreen?" />
                        </div> : null
                }

                {
                    selectedSchool && checkRequiredFields() ? 
                        <div className="school_button_row">                
                            <div className="toast-string">{ toast }</div>
                            <Button 
                                variant="contained" 
                                color="primary"
                                onClick={() => {
                                    submitSchool()
                            }}>Submit</Button> 
                        </div>: null
                }


            </div>
        </div>
}

export default AddSchool;
